import { PlayCircleOutlined } from "@ant-design/icons";
import { Collapse } from "antd";
import { HelpVideo, HelpVideoFolder } from "../../types/helpCentre.types";

/** The server only stores https links; anything else is shown without one. */
const isWebLink = (link: string) => {
	try {
		return new URL(link).protocol === "https:";
	} catch {
		return false;
	}
};

/** A whole card is the link, opening in a new tab that can't reach back into Terra. */
function VideoCard({ video }: Readonly<{ video: HelpVideo }>) {
	const content = (
		<>
			<span className="help-video__thumb" aria-hidden="true">
				<PlayCircleOutlined />
			</span>
			<span className="help-video__text">
				<span className="help-video__title">{video.title}</span>
				{video.description && (
					<span className="help-video__description">{video.description}</span>
				)}
			</span>
		</>
	);
	return isWebLink(video.link) ? (
		<a
			className="help-video"
			href={video.link}
			target="_blank"
			rel="noopener noreferrer"
		>
			{content}
			<span className="sr-only"> (opens in a new tab)</span>
		</a>
	) : (
		<div className="help-video help-video--no-link">{content}</div>
	);
}

/** Groups of video links, all open to start with. */
function VideoFolders({ folders }: Readonly<{ folders: HelpVideoFolder[] }>) {
	if (!folders.length) return <p className="help-empty">No videos yet.</p>;
	return (
		<Collapse
			className="help-faq help-faq--cards help-videos"
			bordered={false}
			expandIconPosition="end"
			defaultActiveKey={folders.map((_, index) => String(index))}
			items={folders.map((folder, index) => ({
				key: String(index),
				label: folder.title,
				children: folder.videos.length ? (
					<ul className="help-videos__grid">
						{/* Videos have no id, and the editor's preview can show two
						    alike, so the position is part of the key. */}
						{folder.videos.map((video, index) => (
							<li key={`${index} ${video.link} ${video.title}`}>
								<VideoCard video={video} />
							</li>
						))}
					</ul>
				) : (
					<p className="help-empty">No videos in this group yet.</p>
				),
			}))}
		/>
	);
}

export default VideoFolders;
